module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Neighborhood-Cohesion",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10.5,10.5882353 L15.75,10.5931751 L15.75,12.3529412 L12.25,12.3529412 L12.25,15.8823529 L10.5,15.8823529 L10.5,10.5882353 Z M59.5,10.5882353 L59.5,15.8823529 L57.75,15.8823529 L57.75,12.3529412 L54.25,12.3529412 L54.25,10.5882353 L59.5,10.5882353 Z M19.25,10.5882353 L21,10.5882353 L21,12.3529412 L19.25,12.3529412 L19.25,10.5882353 Z M10.5,19.4117647 L12.25,19.4117647 L12.25,24.7058824 L10.5,24.7058824 L10.5,19.4117647 Z M10.5,28.2352941 L12.25,28.2352941 L12.25,33.346856 L10.5,33.346856 L10.5,28.2352941 Z M59.5,28.2352941 L59.5,33.5294118 L57.75,33.5294118 L57.75,28.2352941 L59.5,28.2352941 Z M57.75,19.4117647 L59.5,19.4117647 L59.5,24.7058824 L57.75,24.7058824 L57.75,19.4117647 Z M36.75,58.2352941 L42,58.2352941 L42,60 L36.75,60 L36.75,58.2352941 Z M28,58.2352941 L33.25,58.2352941 L33.25,60 L28,60 L28,58.2352941 Z M49,10.5882353 L50.75,10.5882353 L50.75,12.3529412 L49,12.3529412 L49,10.5882353 Z M12.25,35.2941176 L24.5,44.3529412 L24.5,60 L14.7,60 L14.7,51.7647059 L9.8,51.7647059 L9.8,60 L0,60 L0,44.3529412 L12.25,35.2941176 Z M57.75,35.2941176 L70,44.3529412 L70,60 L60.2,60 L60.2,51.7647059 L55.3,51.7647059 L55.3,60 L45.5,60 L45.5,44.3529412 L57.75,35.2941176 Z M35,0 L47.25,9.05882353 L47.25,24.7058824 L37.45,24.7058824 L37.45,16.4705882 L32.55,16.4705882 L32.55,24.7058824 L22.75,24.7058824 L22.75,9.05882353 L35,0 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3adb6f08"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/svg/neighborhood_cohesion.vue
// module id = 611
// module chunks = 1